module.exports = {
    // basic
    'a-company-to-view-templates': 'una compañía para ver las plantillas',
    'template': 'plantilla',
    'templates': 'plantillas',
    'rejection-reason': 'razón por rechazo',

    // raw
    // template
};
